<template>
    <Dashboard
        :title="__('Add image', null, $page.props.profile_locale)"
    >
        <h2 class="border-b-2 text-xl border-gray-200 mb-4">{{__('Add image', null, $page.props.profile_locale)}}</h2>

        <Steps>
            <StepItem
                :title="__('Load images', null, $page.props.profile_locale)"
                :progress="false"
                :active="step >= 1"
                class="w-1/2"
            >
                <template #icon>
                    <SvgIcon
                        class="mx-auto"
                        name="image"
                    />
                </template>
            </StepItem>
            <StepItem
                :title="__('Settings', null, $page.props.profile_locale)"
                :active="step >= 2"
                :width="step >= 2 ? 100 : 0"
                class="w-1/2"
            >
                <template #icon>
                    <SvgIcon
                        class="mx-auto"
                        name="pencil"
                    />
                </template>
            </StepItem>
        </Steps>
        <div class="overflow-hidden">
            <transition
                enter-active-class="transition ease-in-out duration-300 transform"
                :enter-from-class="!back ? 'opacity-0 translate-x-60' : 'opacity-0 -translate-x-60'"
                :enter-to-class="!back ? 'opacity-100 translate-x-0' : 'opacity-100 translate-x-0'"
                leave-active-class="transition ease-in-out duration-300 transform"
                :leave-from-class="!back ? 'opacity-100 translate-x-0' : 'opacity-100 translate-x-0'"
                :leave-to-class="!back ? 'opacity-0 -translate-x-60' : 'opacity-0 translate-x-60'"
                mode="out-in"
                @after-leave="back = false"
            >

                <div v-if="step == 1">
                    <InputLabel type="file" multiple @update="onFileChange($event)" />
                </div>
                <div v-else>
                    <div class="grid lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-3">
                        <div
                            class="border-b pb-2 flex flex-col items-center justify-between"
                            v-for="(img, key) in images"
                            :key="key"
                        >
                            <img :src="img.data" class="w-20 mx-5"/>
                            <InputLabel
                                :label="__('Title', null, $page.props.profile_locale)"
                                v-model="img.title"
                                type="number"
                            />
                        </div>
                    </div>

                    <Button
                        padding="md"
                        class="m-5"
                        @click="saveForm()"
                    >Zapisz</Button>
                </div>
            </transition>
        </div>
    </Dashboard>
</template>

<script>
import Dashboard from '@/Layouts/Dashboard';
import Steps from 'STEPS/Container';
import StepItem from 'STEPS/Item';
import SvgIcon from 'UI/SvgIcon';
import { ref } from '@vue/reactivity';
import InputLabel from 'UI/InputLabel';
import Button from 'UI/Button';

import { useForm } from '@inertiajs/inertia-vue3';


export default {
    components: { Dashboard, Steps, StepItem, SvgIcon, InputLabel, Button },

    setup(props) {
        const
            back = ref(false),
            step = ref(1),
            images = ref([]),
            form = useForm({
                images: images.value
            });

        const
            onFileChange = (e) => {
                var files = e.target ? (e.target.files || e.dataTransfer.files) : e;
                if (!files.length)
                    return;

                for (let i = 0; i < files.length; i++) {
                    const el = files[i];
                    let last = false;

                    if(i == files.length - 1) last = true;
                    createImage(el, i, last);
                }
            },
            createImage = (file, i, last) => {

                var image = new Image();
                var reader = new FileReader();

                reader.onload = (e) => {
                    images.value.push({ data: e.target.result, title: (i+1) });

                    if(last) step.value = 2;
                };
                reader.readAsDataURL(file);
            },
            saveForm = () => {
                form.post(route('dashboard.engrave.pictogram.store'), {
                    preserveScroll: true,
                    onSuccess: () => {
                        console.log('success');
                    },
                })
            };

        return {
            step,
            back,
            images,

            onFileChange,
            createImage,
            saveForm,
        }
    }
}
</script>

<style>

</style>
